import {
  Box,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Typography,
  styled,
} from '@mui/material'

export const StyledMenu = styled(Menu)`
  & .MuiPaper-root {
    border-radius: 6px;
    border: ${({ theme }) => `1px solid ${theme.palette.custom.gray9}`};
    background: ${({ theme }) => theme.palette.custom.white};
    box-shadow: 0 16px 26px 0 rgba(5, 19, 80, 0.07);
    max-width: 246px;
  }

  & .MuiList-root {
    padding: 0;
  }
`

export const StyledMenuItem = styled(MenuItem)`
  padding: 12px 16px 12px 13px;
`

export const StyledListItemIcon = styled(ListItemIcon)`
  width: 26px;
  height: 26px;
  margin-right: 2px;
  min-width: 0;
`

export const Divider = styled(Box)`
  height: 1px;
  background-color: ${({ theme }) => theme.palette.custom.gray10};
  margin: 0 16px;
`

export const StyledIconButton = styled(IconButton)`
  width: 26px;
  height: 26px;
`

export const UnavailableIconButton = styled(IconButton)`
  width: 26px;
  height: 26px;
  padding: 0;
`

export const StyledListItemText = styled(ListItemText)`
  font-size: 15px;
  font-weight: 400;
  line-height: 17px;
`

export const UnavailableWarning = styled(Typography)`
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
  color: #757d9f;
  padding: 12px 16px;
`
